module.exports = __webpack_public_path__ + "static/media/latymerCourt3.2fcd1061.jpg";